<template>
	<div>
		<loading v-if="!loaded" />
		<el-tabs v-model="tabName" v-if="loaded">
			<el-tab-pane label="Pending entry passes" name="first"></el-tab-pane>
			<!-- <el-tab-pane label="New loan" name="second"></el-tab-pane> -->
			<!-- <el-tab-pane label="Loan calculator" name="third"></el-tab-pane> -->
		</el-tabs>
		<div v-if="tabName == 'first' && loaded">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-40">
					<md-field>
						<label>Search by reference code, name or email</label>
						<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-size-20">
					<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">Search
					</md-button>
				</div>
			</div>
			<md-card v-for="(pass, index) in passList">
				<md-card-header data-background-color="orange">
					<h4 class="title">{{index+1}} - {{config.orderlify(pass.id)}}</h4>
				</md-card-header>
				<md-card-content>
					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-45">
							<table>
								<tr>
									<td style="width: 150px">Pass ID</td>
									<td style="width: 40px">:</td>
									<td><b>{{config.orderlify(pass.id)}}</b></td>
								</tr>
								<!-- <tr>
									<td>Reference Code</td>
									<td>:</td>
									<td>{{pass.reference_code}}</td>
								</tr> -->
								<tr>
									<td>Name</td>
									<td>:</td>
									<td>{{pass.name}}</td>
								</tr>
								<tr>
									<td>Sex</td>
									<td>:</td>
									<td>{{config.getGender(pass.gender)}}</td>
								</tr>
								<tr>
									<td>Date of Birth</td>
									<td>:</td>
									<td>{{config.datelify(pass.dob)}}</td>
								</tr>
								<tr>
									<td>Phone Number</td>
									<td>:</td>
									<td>{{pass.phone}}</td>
								</tr>
								<tr>
									<td>E-Mail</td>
									<td>:</td>
									<td>{{pass.email}}</td>
								</tr>
							</table>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-45">
							<table style="border-width: 0px;">
								<tr>
									<td style="width: 150px">Province</td>
									<td style="width:40px">:</td>
									<td>{{pass.province_name.split("||")[1]}}</td>
								</tr>
								<tr>
									<td>District</td>
									<td>:</td>
									<td>{{pass.district_name.split("||")[1]}}</td>
								</tr>
								<tr>
									<td>Commune</td>
									<td>:</td>
									<td>{{pass.commune_name}}</td>
								</tr>
								<tr>
									<td>Address</td>
									<td>:</td>
									<td>{{pass.address_text}}</td>
								</tr>
								<tr>
									<td>Status</td>
									<td>:</td>
									<td>
										<span class="neutral" v-if="pass.status == 'pnd'">{{config.getStatus(pass.status)}}</span>
										<span class="late" v-if="pass.status == 'rjt'">{{config.getStatus(pass.status)}}</span>
										<span class="active" v-if="pass.status == 'apv'">{{config.getStatus(pass.status)}}</span>
									</td>
								</tr>
								<tr v-if="pass.status == 'rjt'">
									<td>Rejected by</td>
									<td>:</td>
									<td>{{pass.approved_by}}</td>
								</tr>
							</table>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-10">
							<div class="md-layout">
								<div class="md-layout-item md-small-size-33 md-size-100 text-center">
									<router-link :to="'/passes/detail/' + pass.hash_id">
										<md-button class="md-just-icon md-simple md-success">
											<md-icon>visibility</md-icon>
											<md-tooltip md-direction="top">View pass information</md-tooltip>
										</md-button>
									</router-link>
								</div>
							</div>
						</div>
					</div>
				</md-card-content>
			</md-card>
			<h4 class="text-center" v-if="passList.length == 0 && loaded == true">No pending applications.</h4>
			<div class="places-buttons text-center" v-if="loadMore" >
				<md-button class="md-primary" @click="searchHandler(true)">Load More</md-button>
			</div>
		</div>

		<!-- <md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="តើអ្នកពិតជាចង់លុបក្រុមហ៊ុននេះពិតមែនទេ ?"
			md-content="ព័ត៌មានក្រុមហ៊ុននឹងត្រូវបានលុបចេញពីបញ្ជីជារាងរហូត។" md-confirm-text="លុប" md-cancel-text="បោះបង់"
			@md-cancel="onCancel" @md-confirm="onDelete" /> -->
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.searchHandler();
			// this.getLocation();
			// this.getSettings();
			// this.searchHandler();
		},

		data() {
			return {
				tabName: "first",
				loaded: false,
				deleteDialogActive: false,
				deleteSelected: '',
				search: {
					text: "",
					status: "pnd"
				},
				loadMore: false,
				passList: []

			}
		},
		methods: {
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/admin/ticket/search", {
					text: this.search.text,
					status: this.search.status,
					offset: more ? this.passList.length : 0
				}).then(data => {
					this.loaded = true;
					this.search.text = "";
					if(data.body.data.length == 10) this.loadMore = true;
					else this.loadMore = false;
					this.passList = data.body.data;
				})

			},
			// showDeleteAction(id) {
			// 	this.deleteSelected = id
			// 	this.deleteDialogActive = true
			// },
			// onDelete() {
			// 	this.$http.post(this.config.api + "/admin/company/delete", {
			// 		company_id: this.deleteSelected
			// 	}, {
			// 		headers: {
			// 			"Content-Type": "application/json"
			// 		}
			// 	}).then(res => {
			// 		if (res.body.status == 'success') {
			// 			this.$notification.notify({
			// 				message: "ក្រុមហ៊ុនបានលុបចេញពីបញ្ចីដោយជោគជ័យ។",
			// 				icon: 'done',
			// 				type: 'success'
			// 			})
			// 			this.getCompany();
			// 			// this.getEndLicense();
			// 			this.searchHandler();
			// 			this.onCancel();
			// 		}
			// 	})
			// },
			// onCancel() {
			// 	this.deleteSelected = ""
			// 	this.deleteDialogActive = false
			// }
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Approvals/View.vue